<template>
  <section class="about-container section-padding-top">
    <div class="about-content">
     <p>This resource features a collection of assessment types produced to support course planning activity in workshops or meetings. This resource was produced by the <a target="blank" href="https://www.mmu.ac.uk/about-us/professional-services/uta">University Teaching Academy (UTA)</a>. For more guidance on assessment, see the <a target="blank" href="https://www.mmu.ac.uk/about-us/professional-services/uta/assessment">assessment section of our website</a>.</p>

     <p>Adapted with permission from Forsyth, R. (2022). Confident Assessment in Higher Education. SAGE</p>
    </div>
    <div class="custom-shape-divider-bottom-1663978418">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
      </svg>
      </div>

      <div id="two"></div>
  </section>

</template>

<script>
export default {

}
</script>

<style scoped>

.custom-shape-divider-bottom-1663978418 {
    position: absolute;
    bottom: 50;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    /* transform: rotate(180deg); */
}

.custom-shape-divider-bottom-1663978418 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 136px;
}

.custom-shape-divider-bottom-1663978418 .shape-fill {
    fill: #F6F6F6;
}
</style>